export function ImageData(title, controlName, imageURL?, imageName?, imageSizeError?, attachedImageFile?, imageExtensionError?): void {
    this.title = title;
    this.controlName = controlName;
    this.imageURL = imageURL;
    this.imageName = imageName;
    this.imageSizeError = imageSizeError;
    this.attachedImageFile = attachedImageFile;
    this.imageExtensionError = imageExtensionError;
}
